import './ClassList.less';

import {
  Button,
  Descriptions,
  Form,
  Select,
  Space,
} from 'antd';
import React, { useCallback, useEffect, useState } from 'react';

import {
  // useVehicleDefaultClassesByCarrier,
  useVehicleDefaultClassUpdateByCarrier,
  useVehicleDefaultClassUpdateGlobal,
} from '../../hooks/apiHooks';
import Container from '../common/Container';
import EditButton from '../common/EditButton';
import ListHeader from '../common/ListHeader';

/*
interface IProps {
  id: string;
  carrier?: Carrier;
  vehicles: Vehicle[];
  defaultClasses: DefaultClass[];
}
*/

const VehicleDefaultClassList = ({ carrier, defaultClasses, id, vehicleDefaultClasses, vehicles, }) => {
//  const { vehicleDefaultClasses } = useVehicleDefaultClassesByCarrier(carrier?.id || 0);
  const updateMutationByCarrier = useVehicleDefaultClassUpdateByCarrier(carrier?.id || 0);
  const updateMutationGlobal = useVehicleDefaultClassUpdateGlobal();

  const [form] = Form.useForm();
  const [isEditing, setIsEditing] = useState(false);

  // Convert vehicleDefaultClasses to form data format
  const convertToFormData = useCallback(() => {
    // vehicleDefaultClasses is now already in the correct format: { defaultClassId: [vehicleIds] }
    // We just need to ensure the keys are properly formatted and return a copy
    const formData = {};
    if (vehicleDefaultClasses && typeof vehicleDefaultClasses === 'object') {
      Object.entries(vehicleDefaultClasses).forEach(([defaultClassId, vehicleIds]) => {
        if (Array.isArray(vehicleIds)) {
          formData[defaultClassId] = [...vehicleIds]; // Create a copy of the array
        }
      });
    }
    return formData;
  }, [vehicleDefaultClasses]);

  // Convert form data back to vehicleDefaultClasses format
  const convertFromFormData = useCallback((formData) => {
    const result = [];
    Object.entries(formData).forEach(([defaultClassId, vehicleIds]) => {
      if (Array.isArray(vehicleIds)) {
        vehicleIds.forEach((vehicleId) => {
          result.push({
            carrierId: carrier?.id,
            defaultClassId: parseInt(defaultClassId),
            vehicleId: vehicleId,
          });
        });
      }
    });
    return result;
  }, [carrier?.id]);

  const onSubmit = useCallback(
    (formData) => {
      const vehicleDefaultClassData = convertFromFormData(formData);
      if (carrier) {
        updateMutationByCarrier.mutate(vehicleDefaultClassData);
      } else {
        updateMutationGlobal.mutate(vehicleDefaultClassData);
      }
    },
    [convertFromFormData, updateMutationByCarrier, updateMutationGlobal, carrier]
  );

  // Set form values when data loads
  useEffect(() => {
    const formData = convertToFormData();
    form.setFieldsValue(formData);
  }, [convertToFormData, form, vehicleDefaultClasses]);

  return (
    <Container id={id}>
      <Form form={form} layout="vertical" onFinish={onSubmit}>
        <Descriptions
          colon={false}
          column={2}
          layout="vertical"
          title={
            <ListHeader>
              <Space>
                <span>Default Class Vehicle Assignments</span>                
              </Space>

              <Space>
                <EditButton
                  color={isEditing ? '#389e0d' : undefined}
                  onClick={() => setIsEditing(!isEditing)}
                >
                  {isEditing ? 'Done' : 'Edit'}
                </EditButton>
              </Space>
            </ListHeader>
          }
        >
          {defaultClasses.map((defaultClass) => (
            <Descriptions.Item
              key={defaultClass.id}
              label={
                <Space>
                  <span>{defaultClass.name}</span>
                </Space>
              }
            >
              <Form.Item
                key={defaultClass.id}
                noStyle
                name={defaultClass.id}
              >
                <Select
                  className="class-list__vehicle-select"
                  disabled={!isEditing}
                  mode="multiple"
                  placeholder="Vehicle Types"
                  style={{ width: '100%' }}
                >
                  {vehicles.map((vehicle) => (
                    <Select.Option key={vehicle.id} value={vehicle.id}>
                      {vehicle.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Descriptions.Item>
          ))}
          {defaultClasses.length % 2 === 1 && (
            <Descriptions.Item>&nbsp;</Descriptions.Item>
          )}
          <Descriptions.Item>
            {isEditing && (
              <Form.Item noStyle>
                <Button
                  htmlType="submit"
                  type="primary"
                >
                  SAVE
                </Button>
              </Form.Item>
            )}
          </Descriptions.Item>
        </Descriptions>
      </Form>
    </Container>
  );
};

export default VehicleDefaultClassList;
